// lib/popupUtils.js
// Ensures a minimum 60-second gap between any two popups.

const LAST_POPUP_KEY = "mc_last_popup_ms";
const MIN_GAP_MS     = 60_000;

export function msUntilNextPopup() {
  try {
    const last    = parseInt(sessionStorage.getItem(LAST_POPUP_KEY) || "0", 10);
    const elapsed = Date.now() - last;
    return Math.max(0, MIN_GAP_MS - elapsed);
  } catch { return 0; }
}

export function recordPopupShown() {
  try { sessionStorage.setItem(LAST_POPUP_KEY, Date.now().toString()); } catch {}
}
